import useApi from "hooks/useApi";
import { useQuery } from "react-query";
import { handleAxiosError } from "./utils";

export interface ReportFolder {
  folderName: string;
  month: string;
  metadataKey: string;
  reportCreatedAt: number;
}

export interface ListReportsResponse {
  reportFolders: ReportFolder[];
}

const LIST_REPORTS_ENDPOINT = "/list-reports";

export default function useQueryListReports() {
  const api = useApi();

  const fetchListReports: () => Promise<ListReportsResponse> = async () => {
    try {
      const { data } = await api.get<ListReportsResponse>(LIST_REPORTS_ENDPOINT);
      return data;
    } catch (e) {
      return handleAxiosError(e);
    }
  };

  return useQuery<ListReportsResponse, string>(["listReports"], fetchListReports);
}
